import { render } from "./BarChartYear.vue?vue&type=template&id=e85e39ae"
import script from "./BarChartYear.vue?vue&type=script&lang=js"
export * from "./BarChartYear.vue?vue&type=script&lang=js"
script.render = render

export default script